module.exports = {
  lunaStringifySprite: require('./dist/sprite/luna-stringify-sprite')
}
